import { createFileRoute } from "@tanstack/react-router";

import ProductAnalytics from "../pages/ProductAnalytics";
import { validateProductAnalyticsSearch } from "../pages/ProductAnalytics/productAnalyticsSearch";
import { RequireAuth } from "../utils/RequireAuth";

// Diverge admins only. The API refuses everyone else as well; this guard only
// keeps a non-admin from landing on an empty page.
export const Route = createFileRoute("/_shell/product-analytics")({
  validateSearch: (search) => validateProductAnalyticsSearch(search as Record<string, unknown>),
  component: ProductAnalyticsRoute,
});

function ProductAnalyticsRoute() {
  return (
    <RequireAuth require="admin">
      <ProductAnalytics />
    </RequireAuth>
  );
}
